import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './Header.css';

export default class Header extends Component {
  state = {
    links: [
      'Home',
      'Band',
      'Choir',
      'Orchestra',
      'Mariachi',
      'Area J 6A',
      'Area B 5A',
      'Calendar',
      'Contacts',
      'Links',
    ],
  };

  render() {
    const { pathname } = window.location;
    const { links } = this.state;

    const leftLink = links.slice(1, 7).map((e, i) => {
      return (
        <Link
          key={i}
          className={pathname === `/${e}` ? 'on_link links' : 'links'}
          to={e === 'Area J 6A' ? '/area-j' : e === 'Area B 5A' ? '/area-b' : `/${e}`}
        >
          {e}
        </Link>
      );
    });

    const rightLink = links.slice(7).map((e, i) => {
      return (
        <Link
          key={i}
          className={pathname === `/${e}` ? 'on_link links' : 'links'}
          to={`/${e}`}
        >
          {e}
        </Link>
      );
    });

    const dropDownLink = links.map((e, i) => {
      return (
        <Link
          key={i}
          className="dropdown_links"
          to={e === 'Home' ? '/' : e === 'Area J 6A' ? '/area-j' : e === 'Area B 5A' ? '/area-b' : `/${e}`}
        >
          {e}
        </Link>
      );
    });

    return (
      <div id="nav_bar" className="nav_bar">
        <div className="menu_bar">
          {!this.props.nav && (
            <Link className="logo_title" to="/">
              Region 20 Music
            </Link>
          )}
          <div className="hamburger">
            {!this.props.nav && (
              <div className="hamburger_icon burger_hover burger-icon" id="b1">
                <div className="burger burger1 burger-icon" id="b2" />
                <div className="burger burger2 burger-icon" id="b3" />
                <div className="burger burger3 burger-icon" id="b4" />
              </div>
            )}
            {this.props.nav && (
              <div
                className={this.props.navClass ? 'sidenav exit' : 'sidenav'}
                id="side-nav"
              >
                <p className="logo_title nav_logo">Region 20 Music</p>
                <div>{dropDownLink}</div>
              </div>
            )}
          </div>
          {leftLink}
        </div>
        <div className="contacts_bar">{rightLink}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js